export default class ApiKey {
  constructor() {
    this.id = null
    this.secret = ''
  }

  static mutations() {
    return {
      setApiKey: (state, key) => state.apiKey = key
    }
  }
}
